<template>
  <LabelledInput label="Size">
    <b-dropdown
      variant="outline-info"
      menu-class="p-0 border-0 w-100"
      block
    >
      <template #button-content>
        {{ sizeOptionText }}
      </template>
      <b-dropdown-item link-class="p-0">
        <b-button-group
          vertical
          class="w-100"
        >
          <b-button
            v-for="s in sizes"
            :key="`btn-info-card-size-${s.value}`"
            :variant="s.value === size ? 'info' : 'outline-info'"
            block
            :data-test="`btn-info-card-size-${s.value}`"
            @click="onSelectSize(s.value)"
          >
            {{ s.text }}
          </b-button>
        </b-button-group>
      </b-dropdown-item>
    </b-dropdown>
  </LabelledInput>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

import { InfoCardSize, InfoCardSizes } from '@/types'

const components = {
  LabelledInput,
}

const props = {
  size: String as PropType<InfoCardSize>,
}

@Component({ components })
export default class SizeInput extends Vue.extend({ props }) {
  sizes: { value: InfoCardSize, text: string }[] = [
    { value: InfoCardSizes.AUTO, text: 'Auto' },
    { value: InfoCardSizes.FILL, text: 'Fill' },
  ]

  get sizeOption () {
    return this.sizes.find(({ value }) => value === this.size)
  }

  get sizeOptionText () {
    return this.sizeOption!.text
  }

  onSelectSize (value: InfoCardSize) {
    this.$emit('update:size', value)
  }
}

</script>
